/**
 * Data object representing the eFax log list item
 * @note This is usually used in the data table as a row. Params don't have default values since this data object is 
 * used to represent data that actually exists.
 */
export class EFaxLogListItemDataObject {
	/**
	 * @param {string} id - Unique identifier of the eFax log item.
	 * @param {string} reportName - Name of the report.
	 * @param {Date} creationDate - Date and time when the eFax log item was created.
	 * @param {string} username - Username of the user who created the eFax log item.
	 * @param {string} faxNumber - Fax number associated with the eFax log item.
	 * @param {EFaxLogStatus} status - Status of the eFax log item.
	 * @param {Date} deliveredDate - Date and time when the eFax log item was delivered.
	 */
	constructor(id, reportName, creationDate, username,  faxNumber, status, deliveredDate) {
		this.id = id;
		this.reportName = reportName;
		this.creationDate = creationDate;
		this.username = username;
		this.faxNumber = faxNumber;
		this.status = status;
		this.deliveredDate = deliveredDate;
	}
}